export default {
    title: '新华数藏——数字版权创作及发行平台',
    description: '数字赋能主流声音，数藏讲好中国故事',
    image: 'https://my-statics-cdn.app.xinhuanet.com/uploadfile/08c7d4d9fb83453d87dec1b4c4587f27.jpg'
}